import { ITranslationProjectTranslationItem } from 'types/translationProject';

type RendererParams = {
  data?: Pick<ITranslationProjectTranslationItem, 'item_info'>;
  value?: ITranslationProjectTranslationItem['confidence'];
};

export function translationConfidenceRenderer(params: RendererParams) {
  const confidence = params.value;
  const similarity = params.data?.item_info?.similarity;

  // Check if translation came from memory (similarity > 0)
  if (similarity !== null && similarity !== undefined && similarity > 0) {
    // Display memory match indicator - compact for 60px width
    return `
      <div style="
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 2px;
        padding: 3px 6px;
        background-color: #e3f2fd;
        border: 1px solid #2196f3;
        border-radius: 10px;
        color: #1976d2;
        font-weight: 600;
        font-size: 11px;
      ">
        ${similarity}
      </div>
    `;
  }

  // No confidence value and no memory match
  if (confidence === null || confidence === undefined) {
    return '<span style="color: #999;">N/A</span>';
  }

  // Display AI confidence - compact for 60px width
  // Convert to percentage if needed (assuming confidence is 0-1, convert to 0-100)
  const confidencePercent = confidence > 1 ? confidence : confidence * 100;
  const displayValue = Math.round(confidencePercent); // Round to integer for compact display

  // Color coding based on confidence level
  let color = '#4caf50'; // Green for high confidence
  let bgColor = '#e8f5e9';
  let borderColor = '#4caf50';

  if (confidencePercent < 60) {
    // Red for low confidence (0-59)
    color = '#f44336';
    bgColor = '#ffebee';
    borderColor = '#f44336';
  } else if (confidencePercent < 80) {
    // Orange for medium confidence (60-79)
    color = '#ff9800';
    bgColor = '#fff3e0';
    borderColor = '#ff9800';
  }
  // else: Green for high confidence (80-100)

  return `
    <div style="
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 3px 6px;
      background-color: ${bgColor};
      border: 1px solid ${borderColor};
      border-radius: 10px;
      color: ${color};
      font-weight: 600;
      font-size: 11px;
    ">
      ${displayValue}
    </div>
  `;
}
